/* eslint-disable sort-keys-fix/sort-keys-fix */
const ScoreSubkeys = {
    NORM19: "norm19",
    REGULAR: "regular",
    SCORE: "score",
    STANINE: "stanine",
    gMatAbilityMBO1: "MBO-1",
    gMatAbilityMBO2: "MBO-2",
    gMatAbilityMBO3: "MBO-3",
    gMatAbilityMBO4: "MBO-4",
};

export default ScoreSubkeys;
